<div class="mx-auto md:px-4 h-[calc(100vh-90px)] flex flex-col">
  <!-- Header + segmented tabs -->
  <div class="flex items-start justify-between mb-4 flex-shrink-0 gap-4 flex-wrap">
    <div>
      <h1 class="text-2xl font-bold text-gray-900">Activity</h1>
      <p class="text-sm text-gray-500 mt-1">{{ subtitle }}</p>
    </div>
    <div class="flex items-center bg-gray-100 rounded-lg p-0.5 shrink-0">
      <button (click)="switchTab('timeline')"
        class="px-3.5 py-1.5 rounded-md text-sm font-semibold transition-all cursor-pointer"
        [class]="activeTab === 'timeline' ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-500 hover:text-gray-700'">
        Timeline
      </button>
      <button (click)="switchTab('summary')"
        class="px-3.5 py-1.5 rounded-md text-sm font-semibold transition-all cursor-pointer"
        [class]="activeTab === 'summary' ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-500 hover:text-gray-700'">
        Daily Totals
      </button>
      <button (click)="switchTab('reporting')"
        class="px-3.5 py-1.5 rounded-md text-sm font-semibold transition-all cursor-pointer"
        [class]="activeTab === 'reporting' ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-500 hover:text-gray-700'">
        Reporting
      </button>
    </div>
  </div>

  <!-- Content (fills remaining space) -->
  <div class="flex-1 min-h-0">
    @if(activeTab === 'timeline') {
      <app-task-timeline></app-task-timeline>
    } @else if(activeTab === 'summary') {
      <app-daily-summary></app-daily-summary>
    } @else {
      <app-my-reporting></app-my-reporting>
    }
  </div>
</div>
